import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-findlanddata',
  templateUrl: './findlanddata.component.html',
  styleUrls: ['./findlanddata.component.css']
})
export class FindlanddataComponent implements OnInit, OnDestroy {
  // Valiable //
  @ViewChild('tb_landno', { static: false }) tb_landno: any;
  showacti = 4;
  farmmerdatalist: any;
  FormCode: UntypedFormGroup;
  constructor(private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    let d = new Date()
    let stringDate = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    console.log('stringDate:', stringDate)

  }
  downloadExcel() {
    let fmcode = this.fmcode;
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit"
    };
    let dt = new Date().toLocaleString('th-TH', options);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tb_landno.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, this.year_txt);
    XLSX.writeFile(wb, 'ข้อมูลแปลง[' + fmcode + ']_' + dt + '.xlsx');
    console.log('tb_landno', this.tb_landno)
  }

  // ข้อมูลชาวไร่
  fmcode = '';
  getfarmmerdata() {
    this.spinner.show();
    let fmcode = this.fmcode;
    let fmdata = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/farmer_basicByfmcode?text_fm=' + fmcode + '';
    axios.get(fmdata).then(res => {
      const data = res.data.recordsets[0];
      this.farmmerdatalist = data;
      this.spinner.hide();
    }).catch(err => { throw (err) });
  }
  // ข้อมูลแปลงอ้อย
  data_cpThis = []; data_Allcp = [];

  year_txt: string
  check(x, data) {
    data = data.sort(function (a, b) { return a.intlandno - b.intlandno });
    this.showacti = x;
    this.data_cpThis = data;
    this.year_txt = x;
  }

  cnt_plant: number;

  lData: { [key: string]: any[] } = {};
  lKeys: string[] = [];
  Load_data_cp() {
    this.spinner.show();
    let fmcode = this.fmcode;
    //let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp_data]&w=[fmcode]='${fmcode}' order by[year]desc,[fmcode],[intlandno]`;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbo].[fnc_search_areas]('${fmcode}')&w=1=1 order by[year_th]desc,[fmcode],[intlandno]`;

    axios.get(url).then(res => {
      this.spinner.hide();
      let data_a = res.data;
      if (data_a.length > 0) {
        this.cnt_plant = data_a.length;
        const groupData = {};
        //this.listLoanyear = data.filter(el => el.year == this.yearTh.substring(0, 2));
        data_a.forEach(entry => {
          const year = entry.year_th;
          if (!groupData[year]) {
            groupData[year] = [];
          }
          groupData[year].push(entry);
        });
        //this.data_group = groupedData;
        this.lData = groupData;
        this.lKeys = Object.keys(groupData).reverse();
        console.log('DatailData: ', this.lData);
        //console.log('DatailKeys: ', this.lKeys);

        let maxl = (this.lKeys[0]);
        setTimeout(() => {
          this.check(maxl, groupData[maxl]);
        }, 200);
      }
      else {
        alert('ไม่พบข้อมูล :' + fmcode)
        this.lData = {};
        this.lKeys = [];
      }
    }).catch(err => { throw (err) })
  }

  printPage() {
    window.print();
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    this.farmmerdatalist = null;
    this.data_cpThis = null;
    this.lData = null;
    this.data_cpThis = null;
  }
}
